import React, {useRef} from 'react';
import {useParams} from 'react-router-dom'

import {Form} from '../components/Form';
import {LoadingIndicator} from '../components/LoadingIndicator';
import {formIsBusy} from '../_helpers/form';
import {FormContainer} from '../components/FormContainer';
import {FormPosts} from '../components/FormPosts';
import {WorkflowDiagram} from '../components/WorkflowDiagram';
import {useForm} from '../_hooks/useForm';
import {useSaveNewEntry} from '../_hooks/useSaveNewEntry';
import {NewEntryFormSubmitButton} from '../components/NewEntryFormSubmitButton';

type NewEntryProps = {};

export const NewEntry: React.FunctionComponent<NewEntryProps> = ({}): JSX.Element => {

    const {formId} = useParams();

    // JDM - temp hack until this can become a configuration option
    if (formId === '266') {
        window.location.href = '/p/adr/new-request';
        return <></>;
    }

    const formSubmitErrorMessageRef = useRef(null);
    const {
        form,
        formState,
        setFormState,
        formIsLoading,
        formLoadErrorMessage,
        formSubmitButtonDisabled
    } = useForm(formId);
    const {
        saveEntry,
        confirmationMessage,
        formIsSubmitting,
        formSubmitErrorMessage,
        formShowConfirmation
    } = useSaveNewEntry(
        form,
        formState,
        setFormState,
        formSubmitErrorMessageRef
    )

    const handleFormSubmit = (saveAsDraft: boolean) => saveEntry(saveAsDraft);

    const containerClasses = [
        'col-12 col-sm-10 offset-sm-1 col-md-8',
        !(form.wpPosts && form.wpPosts.length > 0) && 'offset-md-2',
        (form.wpPosts && form.wpPosts.length > 0) && 'offset-md-0'
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <>
            <div className="row no-gutters" style={{margin: '0 -15px'}}>
                <div className="col-12 text-right">
                    <WorkflowDiagram workflowId={formId} entryId={0}/>
                </div>
            </div>
            <div className="row">
                {form.wpPosts && form.wpPosts.length > 0 &&
                    <div className="col-12 col-sm-10 offset-sm-1 col-md-4 offset-md-0 order-md-1">
                        <FormPosts posts={form.wpPosts}/>
                    </div>
                }
                <div className={containerClasses}>
                    {formLoadErrorMessage && <p className="alert alert-danger">{formLoadErrorMessage}</p>}
                    {formSubmitErrorMessage && <p className="alert alert-danger" ref={formSubmitErrorMessageRef}>{formSubmitErrorMessage}</p>}
                    {formIsLoading && <LoadingIndicator/>}

                    {form.id && <h1 className={'abb-header'}>{form.title}</h1>}

                    {formShowConfirmation && <div className="save-entry-confirmation" dangerouslySetInnerHTML={{__html: confirmationMessage}}/>}

                    {!formShowConfirmation && form.id &&
                        <FormContainer>
                            <Form form={form}
                                  formState={formState}
                                  setFormState={(stateOrCallback: any) => {
                                      setFormState(stateOrCallback)
                                  }}
                                  showPrivate={true}
                            />
                        </FormContainer>
                    }

                    {!formShowConfirmation &&
                        <div className={'text-center m-3'}>
                        <NewEntryFormSubmitButton
                            form={form}
                            isActive={formIsSubmitting}
                            disabled={formIsSubmitting || formSubmitButtonDisabled || formIsBusy(formState)}
                            onClick={handleFormSubmit}
                        />
                        </div>
                    }
                </div>
            </div>
        </>
    );
};